import { createAction, props } from "@ngrx/store";
export const baysSearch = createAction('[tab-bays] BaysSearch', props());
